import * as React from 'react';

import GalleryItemComponent from './gallery-item';
import GalleryLoader from './media-gallery-loader';

import { IMediaGalleryItem } from '../../classes/media-gallery';
import { MediaGalleryAppState } from '../../classes/index';
import { connect, Dispatch } from 'react-redux';
import { getMedia } from '../redux/actions/media-api';

interface StateToProps {
    mediaItems: IMediaGalleryItem[];
}

interface DispatchToProps {
    getMedia: () => any;
}

type GalleryListingProps = StateToProps & DispatchToProps;

class GalleryListingComponent extends React.Component<GalleryListingProps, null> {
    constructor(props: GalleryListingProps) {
        super(props);

        this.props.getMedia();
    }

    render() {
        return (
            <div className="media-gallery-content">
                <div className="media-gallery-list">
                    {
                        this.props.mediaItems.map(item => <GalleryItemComponent key={item.key} data={item} />)
                    }
                </div>

                <GalleryLoader />
            </div>
        );
    }
}

function mapStateToProps(state: MediaGalleryAppState): StateToProps {
    return {
        mediaItems: state.mediaApiModel.filteredMediaList
    }
}

function mapDispatchToProps(dispatch: Dispatch<MediaGalleryAppState>): DispatchToProps {
    return {
        getMedia: () => dispatch(getMedia())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(GalleryListingComponent);


// WEBPACK FOOTER //
// ./app/media-gallery/components/gallery-listing.tsx